import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import TooltipTemplate from "./template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export default class Tooltip {
  constructor() {}

  init = () => {
    const tooltipsElem = _$("[data-tooltip]").sel();

    tooltipsElem.forEach((element) => {
      this.addTooltip(element);
    });
  };

  setTooltipPosition = (position, element, tooltip, fixedPosition = false) => {
    const { bottom, left, right, top } = element.getBoundingClientRect();
    const centerX = left + (right - left) / 2 - tooltip.clientWidth / 2;
    const centerY = top + (bottom - top) / 2 - tooltip.clientHeight / 2;

    const setPosition = (position = "bottom") => {
      switch (position) {
        case "bottom":
          tooltip.style.top = `${bottom + 10}px`;
          tooltip.style.left = `${centerX}px`;
          break;
        case "top":
          tooltip.style.top = `${top - tooltip.clientHeight - 10}px`;
          tooltip.style.left = `${centerX}px`;
          break;
        case "left":
          tooltip.style.left = `${left - tooltip.clientWidth - 10}px`;
          tooltip.style.top = `${centerY}px`;
          break;
        case "right":
          tooltip.style.left = `${right + 10}px`;
          tooltip.style.top = `${centerY}px`;
          break;
        default:
          break;
      }
    };

    setPosition(position);
    if (fixedPosition) return;

    // Check appropriate position
    const positions = ["bottom", "top", "left", "right"];
    positions.every((pos) => {
      if (pos === position) return true;
      const { clientHeight, clientWidth } = document.body;

      const { left, right, top, bottom } = tooltip.getBoundingClientRect();

      if (left < 0 || top < 0 || right > clientWidth || bottom > clientHeight) {
        setPosition(pos);
        const arrow = _$(tooltip).find(".arrow").el();
        arrow.classList.remove(...positions);
        _$(arrow).addClass(pos);
        return true;
      } else {
        return false;
      }
    });
  };

  createTooltip = (
    element,
    tooltipText = "",
    position = "bottom",
    fixedPosition
  ) => {
    const text = tooltipText || element.getAttribute("data-tooltip");
    const dynamicData = element.getAttribute("data-tooltip-i18n-opt") || "{}";

    const tooltip = _$("<div>").addClass("text-tooltip");

    tooltip.html(
      TooltipTemplate({
        text: t(text, JSON.parse(dynamicData)),
        position,
      })
    );

    this.removeTooltip();
    _$("body").append(tooltip.el());

    _$(element).on("mouseleave", () => {
      tooltip.remove();
    });

    this.setTooltipPosition(position, element, tooltip.el(), fixedPosition);
  };

  addTooltip = ({ element, tooltipText, position, fixedPosition }) => {
    _$(element).on("mouseenter", () => {
      this.createTooltip(element, tooltipText, position, fixedPosition);
    });
  };

  removeTooltip = () => {
    _$(".text-tooltip").remove();
  };
}
